<div class="detail-content__actions">
    <div class="content-action content-action--black">
        <ng-container *ngIf="parent?.isFavorite">
            <svg class="pointer is-favorite" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M12 21.1742L10.55 19.8542C5.4 15.1842 2 12.1042 2 8.32422C2 5.24422 4.42 2.82422 7.5 2.82422C9.24 2.82422 10.91 3.63422 12 4.91422C13.09 3.63422 14.76 2.82422 16.5 2.82422C19.58 2.82422 22 5.24422 22 8.32422C22 12.1042 18.6 15.1842 13.45 19.8642L12 21.1742Z" fill="#5E5064"/>
            </svg>
        </ng-container>
        <img [hidden]="parent.isFavorite" class="pointer" width="18" height="18" (click)="addToFavorites(parent)" [alt]="'CARD_DETAIL.ADD_TO_FAVORITES' | translate" src="assets/img/favorite_border_white.svg">
        <span [hidden]="!parent.isFavorite" (click)="deleteFromFavorites(parent)">{{ 'CARD_DETAIL.ADDED_TO_FAVORITES' | translate }}</span>
        <span [hidden]="parent.isFavorite" (click)="addToFavorites(parent)">{{ 'CARD_DETAIL.ADD_TO_FAVORITES' | translate }}</span>
    </div>
    <div class="content-action" *ngIf="parent?.contactEmail && type==='EXHIBITOR'" (click)="showEmailForm()">
        <img class="pointer" width="18" height="18" [alt]="'CARD_DETAIL.CONTACT_TO' | translate" src="assets/img/email.svg">
        <span>{{ 'CARD_DETAIL.CONTACT' | translate }}</span>
    </div>
    <div class="content-action" *ngIf="hasActiveSocialNetworks()">
      <social-networks-share class="share" [parent]="parent"></social-networks-share>
    </div>
</div>
